export const environment = {
    identityUrl: "https://stageapi.gamecashouts.com/auth",
    apiUrl: "https://api.stagebo.gamecashouts.com",
    boUrl: "https://stagebo.gamecashouts.com",
    userApiUrl: "https://stageapi.gamecashouts.com",
    userTrackingUrl: "https://playcharge.g2afse.com/click?pid={pid}&offer_id={offerId}",
    version: "0.1",
    name: "STAGE",
    appName: "Game Cashouts",
    icon: "assets/icons/iconGCO.png"
};
